/**
 * Created by JasonChou on 17/6/20.
 */
import http from '../utils/http';

export const getJsSdkConfigAPI = (url, appId = null) => {
    const params = {
        url
    }

    if (appId) {
        params.appId = appId
    }
    return http.get('/new/h5/jsSdkConfig', {
        params
    });
};


export const getUnionIdByCodeAPI = (code) => {
    return http.get('/new/h5/unionId', {
        params: {
            code
        }
    });
};

/**
 * 登录
 * @param wxUnionId
 * @returns {*}
 */
export const loginByWxUnionIdAPI = (wxUnionId) => {
    return http.post('/new/h5/loginByWxUnionId', {
        data: {
            wxUnionId
        }
    });
};



// WEBPACK FOOTER //
// ./src/apis/weixin.js